<svg width="24" height="24" viewBox="-0.5 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5.64062" y="16.3828" width="15.0848" height="3.99299" rx="1.9965" transform="rotate(-45 5.64062 16.3828)" stroke="currentColor" stroke-width="2"/>
<rect x="0.164062" y="16.6016" width="23.2462" height="11.4317" rx="5.71586" transform="rotate(-45 0.164062 16.6016)" stroke="currentColor" stroke-width="2"/>
</svg>
